<template>
  <form
    id="featured-advisors-new-input"
    class="form-inline featured-advisors-card-form"
    v-show="!hideform"
  >
    <div
      id="blockReference"
      :data-blockid="blockid"
      style="display: none"
    ></div>
    <component
      :is="headingtag"
      class="form-group featured-advisors-mobile-adjustment"
    >
      <span class="featured-advisors-zipcode-workingin">{{ labeltext }}</span>
      <span class="featured-advisors-input-container">
        <input
          ref="place"
          id="featured-advisors-zipcode-input"
          placeholder="ZIP code"
          name="featured-advisors-zipcode-input"
          v-on:keydown.enter.prevent="submitByEnter"
          class="form-control featured-advisors-card-input"
          v-on:focus="handleFocus"
          v-on:blur="handleBlur"
          maxlength="5"
          type="text"
          v-on:keypress="validateNumber"
          v-on:keyup="validateNumberMobile"
          autocomplete="postal-code"
        />
        <label
          for="featured-advisors-zipcode-input"
          class="featured-advisors-zipcode-label"
          >ZIP Code</label
        >
      </span>
    </component>
  </form>

  <div class="loading-message" v-show="loading">Loading...</div>
  <div class="error-message" v-show="errored">
    Please Enter A Valid ZIP Code
  </div>
  <div
    v-if="loaded"
    v-show="!showDefault"
    id="featured-advisors-new"
    class="featured-advisor-container swiper"
    data-component="swiperGlobalCarousel"
  >
    <div class="cards swiper-wrapper">
      <div
        class="swiper-slide"
        v-for="advisor in advisorData"
        :key="advisor.id"
      >
        <div class="card bg-white">
          <div class="card-content" role="group" aria-label="advisor">
            <h4>
              {{ advisor.banner }}
            </h4>
            <div
              :class="
                advisor.normalimage
                  ? 'advisor-normal-image'
                  : 'advisor-custom-icon'
              "
            >
              <img
                :src="advisor.image"
                :alt="
                  advisor.normalimage == false ||
                  advisor.image == '/assets/images/profile-no-image.png'
                    ? advisor.banner
                    : 'Headshot of ' + advisor.name
                "
              />
            </div>
            <div class="advisor-title-address">
              <component :is="advisorheadingtag" class="h5">
                {{ advisor.name }}
              </component>
              <p>
                {{ advisor.advisorTitle }}<br />
                {{ advisor.address.city }}, {{ advisor.address.state }}
              </p>
            </div>
            <div class="card-content-links">
              <!--<a :href="'/' + advisor.firstName.toLowerCase() + '-' + advisor.lastName.toLowerCase()"
                :title="'Contact ' + advisor.name" class="btn btn-primary">Contact</a> -->
              <a
                :href="advisor.advisorPageUrl.toLowerCase()"
                :title="'Contact ' + advisor.name"
                class="btn btn-primary"
                >Contact</a
              >
              <a
                v-if="advisor.banner.indexOf('Private Wealth Advisor') !== -1"
                :title="'See more ' + advisor.banner"
                href="/advisors?advisortype=Private%20Wealth%20Advisor"
                class="btn btn-arrow"
                >See more advisors</a
              >
              <a
                v-else-if="advisor.banner.indexOf('Private Bankers') !== -1"
                :title="'See more ' + advisor.banner"
                href="/advisors?advisortype=Private%20Banker"
                class="btn btn-arrow"
                >See more bankers</a
              >
              <a
                v-else-if="advisor.banner.indexOf('Mortgage Lenders') !== -1"
                :title="'See more ' + advisor.banner"
                href="/advisors?advisortype=Mortage%20Lender"
                class="btn btn-arrow"
                >See more lenders</a
              >
              <a
                v-else-if="advisor.banner.indexOf('Consumer Lenders') !== -1"
                :title="'See more ' + advisor.banner"
                href="/advisors?advisortype=Consumer%20Lender"
                class="btn btn-arrow"
                >See more lenders</a
              >
              <a
                v-else="advisor.banner.indexOf('Business Lenders') !== -1"
                :title="'See more ' + advisor.banner"
                href="/advisors?advisortype=Business%20Lender"
                class="btn btn-arrow"
                >See more lenders</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <button
      class="carousel-control-prev swiper-custom-button-prev"
      href="#carouselControlPrev"
      role="button"
    >
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Previous</span>
    </button>
    <button
      class="carousel-control-next swiper-custom-button-next"
      href="#carouselControlNext"
      role="button"
    >
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Next</span>
    </button>
  </div>
</template>

<script>
import { Loader } from "@googlemaps/js-api-loader";
import { googleApi } from "../../../config/map";
import axios from "axios";

export default {
  data() {
    return {
      advisorData: null,
      errored: false,
      noadvisors: false,
      locationSearch: null,
      index: 0,
      focused: false,
      errored: false,
      loading: false,
      showDefault: false,
      loaded: false,
      radius: 20,
      zipdata: null,
      longdata: null,
      latdata: null,
      hideform: false,
      breakpoint: 992,
      carouselElement: null,
      defaultCarouselElement: null,
      resizeHandler: null,
    };
  },
  mounted() {
    var self = this;
    let advisorsBlockDefault = document.getElementById(
      "featured-advisors-default",
    );
    if (advisorsBlockDefault) {
      advisorsBlockDefault.classList.add("default-advisors-active");
    }
    this.showDefault = true;

    this.resizeHandler = function () {
      if (self.carouselElement) {
        if (window.innerWidth < self.breakpoint) {
          self.carouselActivate();
        } else {
          self.carouselRemove();
        }
      }

      if (self.defaultCarouselElement) {
        if (window.innerWidth < self.breakpoint) {
          self.defaultCarouselActivate();
        } else {
          self.defaultCarouselRemove();
        }
      }
    };

    this.initializeDefaultCarousel();

    window.addEventListener("resize", this.resizeHandler);

    if (self.hidezip === "true") {
      self.hideform = true;
      //self.getByZipCode(self.zipcode);
      self.getByLocationCode(self.locationcode);
    } else {
      setTimeout(function () {
        self.getPersonalizationData();
      }, 4000);
    }
  },
  beforeUnmount() {
    this.cleanupCarousel();
    this.cleanupDefaultCarousel();
  },
  computed: {
    isMobile() {
      return this.$mq != "desktop";
    },
  },
  methods: {
    initializeCarousel() {
      setTimeout(() => {
        this.$nextTick(() => {
          this.carouselElement = document.getElementById(
            "featured-advisors-new",
          );
          if (this.carouselElement) {
            if (this.carouselElement.swiper) {
              this.carouselElement.swiper.destroy(true, true);
            }

            if (window.innerWidth < this.breakpoint) {
              this.carouselActivate();
            } else {
              this.carouselRemove();
            }
          }
        });
      }, 100);
    },

    initializeDefaultCarousel() {
      setTimeout(() => {
        this.$nextTick(() => {
          this.defaultCarouselElement = document.getElementById(
            "featured-advisors-default",
          );
          if (this.defaultCarouselElement) {
            if (this.defaultCarouselElement.swiper) {
              this.defaultCarouselElement.swiper.destroy(true, true);
            }

            if (window.innerWidth < this.breakpoint) {
              this.defaultCarouselActivate();
            } else {
              this.defaultCarouselRemove();
            }
          }
        });
      }, 100);
    },

    carouselActivate() {
      if (!this.carouselElement) return;

      if (typeof HERO_swiperGlobalCarousel !== "undefined") {
        HERO_swiperGlobalCarousel.initCarousel(this.carouselElement);
      }
    },

    carouselRemove() {
      if (!this.carouselElement) return;

      if (this.carouselElement.swiper) {
        this.carouselElement.swiper.destroy(true, true);
      }
    },

    cleanupCarousel() {
      if (this.resizeHandler) {
        window.removeEventListener("resize", this.resizeHandler);
      }

      if (this.carouselElement && this.carouselElement.swiper) {
        this.carouselElement.swiper.destroy(true, true);
      }
    },

    defaultCarouselActivate() {
      if (!this.defaultCarouselElement) return;
      if (this.defaultCarouselElement.swiper) return;

      if (typeof HERO_swiperGlobalCarousel !== "undefined") {
        HERO_swiperGlobalCarousel.initCarousel(this.defaultCarouselElement);
      }
    },

    defaultCarouselRemove() {
      if (!this.defaultCarouselElement) return;
      if (this.defaultCarouselElement.swiper) {
        this.defaultCarouselElement.swiper.destroy(true, true);
      }
    },

    cleanupDefaultCarousel() {
      if (this.defaultCarouselElement && this.defaultCarouselElement.swiper) {
        this.defaultCarouselElement.swiper.destroy(true, true);
      }
    },
    ensureGoogleMapsLoaded() {
      // If API is already loaded, return resolved promise
      if (typeof google !== "undefined" && google.maps) {
        return Promise.resolve();
      }
      // If loader is already in progress, return existing promise
      if (window.googleMapsApiLoader) {
        return window.googleMapsApiLoader;
      }
      const loader = new Loader({
        apiKey:
          googleApi && googleApi.mapKey
            ? googleApi.mapKey
            : process.env.GOOGLE_API_KEY,
        version: "weekly",
        libraries: ["places"],
      });
      window.googleMapsApiLoader = loader
        .load()
        .then(() => true)
        .catch((error) => {
          console.error("Error loading Google Maps API:", error);
          throw error;
        });
      return window.googleMapsApiLoader;
    },
    async getAdvisors(lat, long, type) {
      let advisorCatFilter = "";
      let idofblock = $("#blockReference").data("blockid");
      let advisorsBlockDefault = document.getElementById(
        "featured-advisors-default",
      );
      if (type) {
        advisorCatFilter = "&advisorType=" + this.advisortypecategory;
      }
      let featuredAdvisorsApi =
        "/api/featured-advisors?lat=" +
        lat +
        "&lng=" +
        long +
        "&radius=" +
        this.radius +
        "&blockid=" +
        idofblock +
        advisorCatFilter;
      this.loading = true;
      axios
        .get(featuredAdvisorsApi)
        .then((response) => {
          advisorsBlockDefault.classList.remove("default-advisors-active");
          this.loading = false;
          this.advisorData = response.data.advisors;

          this.showDefault = false;
          this.loaded = true;

          // check for data
          if (
            this.hidezip === "true" &&
            (this.advisorData.length === 0 || this.advisorData === undefined)
          ) {
            this.noadvisors = true;
            this.showDefault = true;
            advisorsBlockDefault.classList.add("default-advisors-active");

            var noAdvisors = document.getElementsByClassName(
              "no-advisors-message",
            );
            noAdvisors[0].classList.add("show");
          } else if (this.advisorData.length <= 0 && this.radius == 50) {
            this.errored = true;
            this.showDefault = true;
            advisorsBlockDefault.classList.add("default-advisors-active");
          } else if (this.advisorData.length <= 0) {
            this.radius = 50;
            this.getAdvisors(lat, long, this.advisortypecategory);
          } else {
            this.initializeCarousel();
          }
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        });
    },

    async getByLocationCode(locationCode) {
      this.radius = 20;
      this.errored = false;

      let advisorsBlockDefault = document.getElementById(
        "featured-advisors-default",
      );

      let featuredAdvisorsApi =
        "/api/featured-advisors-by-location?locationcode=" + locationCode;
      this.loading = true;
      axios
        .get(featuredAdvisorsApi)
        .then((response) => {
          advisorsBlockDefault.classList.remove("default-advisors-active");
          this.loading = false;
          this.advisorData = response.data.advisors;

          this.showDefault = false;
          this.loaded = true;

          // check for data
          if (
            this.hidezip === "true" &&
            (this.advisorData.length === 0 || this.advisorData === undefined)
          ) {
            this.noadvisors = true;
            this.showDefault = true;
            advisorsBlockDefault.classList.add("default-advisors-active");

            var noAdvisors = document.getElementsByClassName(
              "no-advisors-message",
            );
            noAdvisors[0].classList.add("show");
          } else if (this.advisorData.length <= 0 && this.radius == 50) {
            this.errored = true;
            this.showDefault = true;
            advisorsBlockDefault.classList.add("default-advisors-active");
          } else if (this.advisorData.length <= 0) {
            this.radius = 50;
            this.getAdvisors(lat, long, this.advisortypecategory);
          } else {
            this.initializeCarousel();
          }
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        });
    },
    async getByZipCode(zipcode) {
      this.radius = 20;
      this.errored = false;

      let advisorsBlockDefault = document.getElementById(
        "featured-advisors-default",
      );

      var _ = this;
      let longitude = "";
      let latitude = "";
      await this.ensureGoogleMapsLoaded();
      if (typeof google !== "undefined" && google.maps) {
        let geocoder = new google.maps.Geocoder();
        geocoder.geocode(
          { address: "zipcode " + zipcode },
          (results, status) => {
            this.loading = true;
            if (status == google.maps.GeocoderStatus.OK) {
              this.loading = false;

              latitude = results[0].geometry.location.lat();
              longitude = results[0].geometry.location.lng();

              this.getAdvisors(latitude, longitude, this.advisortypecategory);
              return results;
            } else {
              console.error("Request failed.");
              this.errored = false;
            }
          },
        );
      }
    },

    async submitByEnter() {
      this.radius = 20;
      this.errored = false;
      let inputValue = this.$refs.place.value;
      let advisorsBlockDefault = document.getElementById(
        "featured-advisors-default",
      );
      if (!inputValue) {
        this.focused = true;
        this.showDefault = true;
        this.errored = false;
        advisorsBlockDefault.classList.add("default-advisors-active");
      } else {
        if (inputValue.length == 5 && !isNaN(inputValue)) {
          var _ = this;
          let longitude = "";
          let latitude = "";
          await this.ensureGoogleMapsLoaded();
          if (typeof google !== "undefined" && google.maps) {
            let geocoder = new google.maps.Geocoder();
            geocoder.geocode(
              { address: "zipcode " + inputValue },
              (results, status) => {
                this.loading = true;
                if (status == google.maps.GeocoderStatus.OK) {
                  this.loading = false;

                  latitude = results[0].geometry.location.lat();
                  longitude = results[0].geometry.location.lng();

                  window.localStorage.setItem("userZip", inputValue);
                  window.localStorage.setItem("longData", longitude);
                  window.localStorage.setItem("latData", latitude);
                  this.getAdvisors(
                    latitude,
                    longitude,
                    this.advisortypecategory,
                  );
                  return results;
                } else {
                  console.error("Request failed.");
                  this.errored = false;
                }
              },
            );
          }
        } else {
          this.errored = true;
        }
      }
    },
    handleBlur() {
      let featuredAdvisorInput = document.getElementById(
        "featured-advisors-zipcode-input",
      );
      let advisorsBlockDefault = document.getElementById(
        "featured-advisors-default",
      );
      if (!featuredAdvisorInput.value) {
        this.focused = true;
        featuredAdvisorInput.value = "";
        this.showDefault = true;
        this.errored = false;
        advisorsBlockDefault.classList.add("default-advisors-active");
      }
    },
    handleFocus() {
      this.focused = true;
    },
    validateNumber(event) {
      let keyCode = event.keyCode;
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
    },
    validateNumberMobile(event) {
      event.target.value = event.target.value.replace(/[^\d]/g, "");
      return false;
    },
    async allowLocation() {
      if (navigator.userAgent.indexOf("iPhone") != -1) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            // if it is iPhone and user hits accept I use the Browser lat and long
            this.getAdvisors(
              position.coords.latitude,
              position.coords.longitude,
              this.advisortypecategory,
            );
          },
          (error) => {
            console.log(error.message);
            // if not, I use the existing lat and long
            this.getAdvisors(
              this.latitude,
              this.longitude,
              this.advisortypecategory,
            );
          },
        );
      } else {
        let advisorsBlockDefault = document.getElementById(
          "featured-advisors-default",
        );
        advisorsBlockDefault.classList.add("default-advisors-active");
        this.showDefault = true;
      }
    },
    getInitialAdvisors() {
      var self = this;
      let advisorsBlockDefault = document.getElementById(
        "featured-advisors-default",
      );
      let featuredAdvisorInput = document.getElementById(
        "featured-advisors-zipcode-input",
      );

      if (self.zipdata) {
        if (featuredAdvisorInput) {
          featuredAdvisorInput.value = self.zipdata;
        }
        self.getAdvisors(self.latdata, self.longdata, this.advisortypecategory);
        advisorsBlockDefault.classList.remove("default-advisors-active");
      } else {
        // use browser geolocation lat and long if no data
        this.allowLocation();
        advisorsBlockDefault.classList.add("default-advisors-active");
        this.showDefault = true;
      }
    },
    getPersonalizationData() {
      var self = this;
      var cached_userZip = window.localStorage.getItem("userZip");
      if (cached_userZip) {
        this.zipdata = cached_userZip;
        this.longdata = window.localStorage.getItem("longData");
        this.latdata = window.localStorage.getItem("latData");
        this.getInitialAdvisors();
      } else {
        if (window.localStorage.getItem("stopPersonalization") != "true") {
          var ipaddressTest = HERO_getQueryStringParam("ipaddress");
          var passData = "";
          if (HERO_getQueryStringParam("ipaddress") != "") {
            passData = "?ipaddress=" + ipaddressTest;
          }

          $.ajax({
            type: "GET",
            url: "/api/personalization" + passData,
            contentType: "application/json; charset=utf-8",
            success: function (data) {
              if (
                data.geoLocationState == null &&
                data.ipAddress == null &&
                data.geoLocationPostalZip == null &&
                data.geoLongitude == null &&
                data.geoLatitude == null
              ) {
                window.localStorage.setItem("stopPersonalization", "true");
              } else if (
                data.geoLocationPostalZip != null &&
                data.geoLongitude != null &&
                data.geoLatitude != null
              ) {
                if (data.geoLocationPostalZip != null) {
                  self.zipdata = data.geoLocationPostalZip;
                  window.localStorage.setItem(
                    "userZip",
                    data.geoLocationPostalZip,
                  );
                }
                if (data.geoLongitude != null) {
                  self.longdata = data.geoLongitude;
                  window.localStorage.setItem("longData", data.geoLongitude);
                }
                if (data.geoLatitude != null) {
                  self.latdata = data.geoLatitude;
                  window.localStorage.setItem("latData", data.geoLatitude);
                }
                if (data.geoLocationState != null) {
                  window.localStorage.setItem(
                    "geoState",
                    data.geoLocationState,
                  );
                }
                if (data.ipAddress != null) {
                  window.localStorage.setItem("ipAddress", data.ipAddress);
                }
                setTimeout(function () {
                  self.getInitialAdvisors();
                }, 400);
              } else {
                self.getInitialAdvisors();
              }
            },
            error: function () {
              self.getInitialAdvisors();
            },
          });
        }
      }
    },
  },
  props: {
    zipcode: String,
    longitude: String,
    latitude: String,
    advisortypecategory: String,
    labeltext: String,
    blockid: String,
    hidezip: String,
    locationcode: String,
    headingtag: String,
    advisorheadingtag: String,
  },
  watch: {},
};
</script>
